(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('StatsMonthlyBalanceController', StatsMonthlyBalanceController);

    StatsMonthlyBalanceController.$inject = ['$scope', '$http', '$state', 'StatsMonthlyBalance', 'StatsMonthlyBalanceTotalAmount', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'DateUtils'];

    function StatsMonthlyBalanceController($scope, $http, $state, StatsMonthlyBalance, StatsMonthlyBalanceTotalAmount, ParseLinks, AlertService, paginationConstants, pagingParams, DateUtils) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.excel = excel;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.searchQuery = {
            field: pagingParams.field,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate
        };

        initDatePicker();

        if (!pagingParams.firstRun) {
            loadAll();
            getTotalMonthlyBalance();
        }

        function initDatePicker() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    $(this).val(vm.searchQuery.fromDate);
                } else if ($(this).attr('name') == 'to') {
                    $(this).val(vm.searchQuery.toDate);
                }
            });

            $('.date-picker').datepicker({autoclose: true});
        }

        function loadAll() {
            StatsMonthlyBalance.get({
                field: pagingParams.field,
                fromDate: pagingParams.fromDate,
                toDate: pagingParams.toDate,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.statistics = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                field: vm.searchQuery.field,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                serviceType: vm.searchQuery.serviceType,
                status: vm.searchQuery.status,
                mode: vm.searchQuery.mode,
                firstRun: false
            });
        }

        function search() {
            $('.input-daterange input').each(function() {
                if ($(this).attr('name') == 'from') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'to') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.transition();
        }

        function getTotalMonthlyBalance() {
            StatsMonthlyBalanceTotalAmount.get({
                field: vm.searchQuery.field,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate
            }, function (data) {
                vm.stats = data;
            })
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.searchQuery = {
                field: "",
                fromDate: null,
                toDate: null
            };
            vm.transition();
        }

        function excel() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'to') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
            var data = "field=" + vm.searchQuery.field + "&fromDate=" + vm.searchQuery.fromDate + '&toDate=' + vm.searchQuery.toDate;

            $http({
                url: 'api/stats-monthly-balance-excel',
                method: 'POST',
                responseType: 'arraybuffer',
                data: data,
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                }
            }).success(function (data) {
                var blob = new Blob([data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                saveAs(blob, 'statistics-monthly-balance-' + DateUtils.currentTimestamp() + '.xlsx');
            }).error(function () {

            });
        }

    }
})();
